<div *ngIf="event" class="container">
  <div class="go-back mt-4 d-flex justify-content-between align-items-center">
    <span (click)="goBack()" style="cursor: pointer;"> <img src="/assets/ic_arrow_left_blue.svg" alt="" /> &nbsp; {{ translations.go_back }}</span>
    
    <div class="navigation-buttons">
      <a *ngIf="previousProduct" [routerLink]="['/eventos', event.id, 'produtos', previousProduct.id]" class="text-decoration-none me-3" style="cursor: pointer;">
        <img src="/assets/ic_arrow_left_blue.svg" alt="" /> &nbsp; {{ translations.previous }}
      </a>
      <a *ngIf="nextProduct" [routerLink]="['/eventos', event.id, 'produtos', nextProduct.id]" class="text-decoration-none" style="cursor: pointer;">
        {{ translations.next }} &nbsp; <img src="/assets/ic_arrow_right_blue.svg" alt="" />
      </a>
    </div>
  </div>
  <div class="row mt-4" *ngIf="product">
    <div class="col-md-7">
      <ul id="lightSlider" class="gallery list-unstyled">
        <li *ngFor="let video of product.lotVideos; let i = index" [attr.data-thumb]="video.thumbnail"
          style="height: 100%; min-height: 420px" (click)="openGallery(i)">
          <iframe class="w-100 yt-product-video" height="100%" [src]="video.embedUrl | safe" frameborder="0"
            allowfullscreen></iframe>
        </li>
        <li *ngFor="let image of product.lotImages; let i = index" [attr.data-thumb]="image.imageLotUrl" style="height: 100%;min-height: 420px;"
          (click)="openGallery(product.lotVideos.length + i)">
          <img [src]="image.imageLotUrl" alt="" class="img-fluid"
            style="width: 100%; object-fit: cover; cursor: zoom-in;" />
        </li>
      </ul>
    </div>
    <div class="col-md-5 ps-sm-4 mt-3 mt-sm-0" *ngIf="product">
      <div>
        <span class="badge bg-primary rounded-0 px-4 py-2">{{ product.badge }}</span>
      </div>
      <div class="row mt-2">
        <div class="col-12 product-name">
          <p class="lot-number m-0"><small class="lot-label">LOTE:</small><br><strong>{{ product.number }}</strong></p>
          <p>{{ product.title }}</p>
        </div>
      </div>
      <div class="row product-address">
        <div class="col-2"><img src="/assets/shield-circle.svg" class="me-3" /></div>
        <div class="col-10">
          <a class="link-primary" [routerLink]="['/eventos', event.id]"><strong>{{ event.title }}</strong></a>
          <p class="small">{{ product.formatedCity() }}</p>
        </div>
      </div>
      <div class="product-value mt-3" *ngIf="!product.isSold(event)">
        <p class="small mb-0" style="font-size: 0.7rem">{{ product.valueTitle }}</p>
        <span class="text-muted"
          *ngIf="!!product.totalValue && !!product.originalPrice && product.originalPrice > product.totalValue">De:
          <s>{{ product.originalPrice | currency: translations.currency }}</s> {{ translations.by }}<br /></span>
        <span class="text-muted" *ngIf="!!product.totalValue && product.saleType === 'pre-bid'"><span class="total-value">{{ product.value | currency: translations.currency }} <small style="font-size: 20px;color: gray;"  *ngIf="product.captation > 1">x{{ product.captation }} = {{ product.totalValue | currency: translations.currency }}</small></span></span>
        <span class="text-muted" *ngIf="!!product.totalValue && product.saleType !== 'pre-bid'"><span class="total-value">{{ product.totalValue | currency: translations.currency }} </span></span>
        <span class="text-muted" *ngIf="!product.totalValue"><span class="total-value">{{ translations.to_consult }}</span></span>
        <!-- {{ product.unitName ? '/' + product.unitName : '' }} -->
      </div>

      <div class="product-info-credit-card py-2 text-muted">
        <div [outerHTML]="product.paymentConditions"></div>
        <p class="m-0"> <small><small>{{ product.paymentConditionObservation }}</small></small></p>
      </div>

      <div *ngIf="product.saleType === 'pre-bid' && !product.isSold(event) && !product.prebidClosed(event) && !!product.totalValue">
        <div class="product-value mt-3">
          <p class="small mb-0" style="font-size: 0.7rem">{{ translations.next_bid }}</p>
          <span class="text-muted">
            <span class="total-next-value">{{ product.nextBid | currency: translations.currency }}</span>
            <small style="font-size: 20px;color: gray;margin-left: 5px;">x{{product.captation}} = {{ product.nextBid * product.captation | currency: translations.currency }}</small>
          </span>
        </div>
      </div>

      <button class="btn btn-primary w-100 btn-negotiate mt-4" (click)="onClickNegociar()"
        [disabled]="product.isSold(event) || product.prebidClosed(event)" [class.is-sold]="product.isSold(event) || product.prebidClosed(event)">
        <ng-container *ngIf="product.isSold(event)">
          {{ translations.sold }}
        </ng-container>
        <ng-container *ngIf="product.prebidClosed(event) && !product.isSold(event)">
          {{ translations.pre_bid_closed }}
        </ng-container>
        <ng-container *ngIf="!product.isSold(event) && !product.prebidClosed(event)">
          {{ product.saleType === 'pre-bid' ? translations.want_bid : translations.bargain }}
        </ng-container>
      </button>
      <!-- <div class="row product-info-freight py-2 my-4">
        <div class="col-2"><img src="/assets/frete.svg" class="me-3" /></div>
        <div class="col-10">
          <p class="mb-0">
            Frete facilitado por transportadora terceirizada. Entrega em até 20 dias úteis
          </p>
        </div>
      </div> -->
    </div>
  </div>

  <hr class="text-muted mt-5" />
  <div class="product-description mt-4" *ngIf="product">
    <div [outerHTML]="product.description"></div>
  </div>
</div>

<p-dialog [(visible)]="modalDealShow" [draggable]="false" *ngIf="product && event">
  <form class="negotiation" [formGroup]="form">
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-floating mb-3">
          <input id="name" type="text" class="form-control" autocomplete="name" placeholder="{{ translations.full_name }}"
            formControlName="name" required />
          <label for="name">{{ translations.full_name }}*</label>
          <div *ngIf="fieldInvalid('name')" class="text-danger my-2">
            <span><small>{{ translations.name }} {{ translations.is_required }}</small></span>
          </div>
        </div>
        <div class="form-floating mb-3">
          <input id="email" type="email" class="form-control" autocomplete="email" placeholder="E-mail*"
            formControlName="email" required />
          <label for="email">E-mail*</label>
          <div *ngIf="fieldInvalid('email')" class="text-danger my-2">
            <span><small>Email {{ translations.is_required }}</small></span>
          </div>
        </div>
        <div class="form-floating mb-3">
          <input id="phone" type="tel" class="form-control" autocomplete="tel-national" placeholder="{{ translations.phone_cel }}"
            formControlName="phoneNumber" mask="(00) 0000-0000||(00) 00000-0000" appPhoneBr required />
          <label for="phone">{{ translations.phone_cel }}*</label>
          <div *ngIf="fieldInvalid('phoneNumber')" class="text-danger my-2">
            <span *ngIf="form.get('phoneNumber')?.hasError('phoneBr'); else phoneRequired"><small>{{ translations.phone }}
                {{ translations.invalid }} — DDD + número.</small></span>
            <ng-template #phoneRequired>
              <span><small>{{ translations.phone }} {{ translations.is_required }}</small></span>
            </ng-template>
          </div>
        </div>

        <div class="form-floating mb-3" *ngFor="let extraField of event.dealExtraFields">
          <input id="ex-field-{{extraField.name}}" type="text" class="form-control" placeholder=""
            [formControlName]="extraField.name" />
          <label for="ex-field-{{extraField.name}}">{{extraField.name}}{{ extraField.required ? '*' : '' }}</label>
          <div *ngIf="extraField.required && fieldInvalid(extraField.name)" class="text-danger my-2">
            <span><small>{{extraField.name}} {{ translations.is_required }}</small></span>
          </div>
        </div>
        <!-- nome do atendente -->
        <div class="form-floating mb-3">
          <input id="attendantName" type="text" class="form-control" autocomplete="attendant" placeholder="{{ translations.attendant }}"
            formControlName="attendantName" />
          <label for="attendantName">{{ translations.attendant }}</label>
        </div>

        <div class="form-floating mb-3" [hidden]="product.saleType === 'pre-bid'">
          <textarea id="message" class="form-control mt-3" placeholder="Mensagem" formControlName="message"
            rows="4"></textarea>
          <label for="message">{{ translations.message }}</label>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div>
          <span class="badge rounded-0 px-4 py-2">{{ product.badge }}</span>
        </div>
        <div class="product-value mt-3">
          <p class="small mb-0" style="font-size: 0.7rem">{{ product.valueTitle }}</p>
          <span class="text-muted"
            *ngIf="!!product.totalValue && !!product.originalPrice && product.originalPrice > product.totalValue">De:
            <s>{{ product.originalPrice | currency: translations.currency }}</s> Por:<br /></span>
          <span class="text-muted" *ngIf="!!product.totalValue"><span class="total-value">{{ product.totalValue | currency: translations.currency }}</span></span>
          <span class="text-muted" *ngIf="!product.totalValue"><span class="total-value">{{ translations.to_consult }}</span></span>
          <!-- {{ product.unitName ? '/' + product.unitName : '' }} -->

        </div>

        <div class="product-info-credit-card py-2 text-muted">
          <div [outerHTML]="product.paymentConditions"></div>
          <p class="m-0"> <small><small>{{ product.paymentConditionObservation }}</small></small></p>
        </div>

        <div *ngIf="product.saleType === 'pre-bid' && !product.isSold(event) && !product.prebidClosed(event)">
          <div class="product-value mt-3">
            <p class="small mb-0" style="font-size: 0.7rem">{{ translations.next_bid }}</p>
            <span class="text-muted">
              <span class="total-next-value">{{ product.nextBid * product.captation | currency: translations.currency }}</span>
            </span>
          </div>
        </div>

        <button type="submit" class="btn btn-primary mt-3 w-100 btn-negotiate" (click)="onClickConfirmNegociar()"
          [disabled]="!form.valid || processing">
          {{ product.saleType === 'pre-bid' ? translations.want_bid : translations.bargain }}
        </button>

        <div *ngIf="dealRes?.success === false" class="text-danger my-2">
          <span><small>{{ dealRes?.message }}</small></span>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [(visible)]="modalDealSuccessShow" [draggable]="false" *ngIf="product && dealRes">
  <div class="my-3 mb-5">
    <h2 class="success-title text-center"><strong>{{ translations.sent }}</strong></h2>
    <p class="text-muted my-5">
      {{ dealRes.message }}
    </p>
  </div>
</p-dialog>

<p-dialog [dismissableMask]="true" [modal]="true" [(visible)]="showGallery" [draggable]="false" *ngIf="event"
  [style]="{ 'min-width': '35vw', 'max-width': '95vw', 'max-height': '95vh' }">
  <div class="text-center gallery-container position-relative">
    <!-- Botão Anterior -->
    <button
      *ngIf="currentGalleryIndex > 0"
      class="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-3"
      style="z-index: 1000; opacity: 0.8; width: 40px; height: 40px; padding: 8px; border-radius: 50%;"
      (click)="previousGalleryItem()">
      <img src="/assets/ic_arrow_left_blue.svg" alt="Anterior" style="width: 20px; height: 20px;" />
    </button>

    <!-- Conteúdo (Imagem ou Vídeo) -->
    <div *ngIf="getCurrentGalleryItem().type === 'image'">
      <img class="img-fluid rounded" [src]="galleryImg" />
    </div>
    <div *ngIf="getCurrentGalleryItem().type === 'video'" style="min-height: 420px;">
      <iframe class="w-100 rounded" height="420px" [src]="getCurrentGalleryItem().embedUrl | safe" frameborder="0"
        allowfullscreen></iframe>
    </div>

    <!-- Botão Próximo -->
    <button
      *ngIf="currentGalleryIndex < galleryItems.length - 1"
      class="btn btn-light position-absolute top-50 end-0 translate-middle-y me-3"
      style="z-index: 1000; opacity: 0.8; width: 40px; height: 40px; padding: 8px; border-radius: 50%;"
      (click)="nextGalleryItem()">
      <img src="/assets/ic_arrow_right_blue.svg" alt="Próximo" style="width: 20px; height: 20px;" />
    </button>

    <!-- Contador -->
    <div class="position-absolute bottom-0 start-50 translate-middle-x mb-3 bg-dark text-white px-3 py-1 rounded"
      style="opacity: 0.8; font-size: 0.9rem;">
      {{ currentGalleryIndex + 1 }} / {{ galleryItems.length }}
    </div>
  </div>
</p-dialog>
